import { IState } from "../state";

export class Fuel {
  static toggleIsOpenFuelFilters(state: IState) {
    const newState = Object.assign({}, state);
    newState.fuel.isOpen = !state.fuel.isOpen;

    return newState;
  }
}
